import { TmInvalidEnumValueError } from '@/core/error/tmInvalidEnumValueError'

/**
 *
 * @throws { TmInvalidEnumValueError }
 */
export function mapStringOrNumberToEnum<T extends { [key: string]: string | number }>(
  val: string | number,
  enumObj: T,
): T[keyof T] {
  const enumValues = Object.values(enumObj) as Array<string | number>

  if (enumValues.includes(val)) {
    return val as T[keyof T]
  }

  throw new TmInvalidEnumValueError(val, enumObj)
}
